export enum InsuranceTableType {
    BeforeClosingMissing = 0,
    BeforeClosingGood = 1,
    ClosedMissing = 2,
    ClosedGood = 3,
    Repaid = 4,
    Recycle = 5,
}
